import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type { TeacherOptionTypes } from 'teacher-ui-client/components/base/select/teacher/options'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default class CopyClassesController extends Controller {
  @tracked fromSubscriptionType?: SubscriptionType

  @tracked hideEmptyClasses: boolean = false

  @tracked selectedIds: string[] = []

  @tracked teacherId?: TeacherOptionTypes | string

  queryParams = ['fromSubscriptionType', 'hideEmptyClasses', 'selectedIds', 'teacherId']
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/copy-classes': CopyClassesController
  }
}
